import { useTranslation } from "react-i18next";

import { CUSTOM_CONFIRM_TYPES, CustomConfirm } from "components";
import { useDeleteTyreMutation } from "modules/IncompleteTyresDashboard/components/DeleteTyreModal/hooks";

import type { Tyre } from "models";

type DeleteTyreModalProps = {
  tyre: Tyre | null;
  onClose: () => void;
};

export const DeleteTyreModal = ({ tyre, onClose }: DeleteTyreModalProps) => {
  const { t } = useTranslation();

  const { mutateAsync: deleteTyre, isPending: isDeleteTyrePending } = useDeleteTyreMutation();

  const handleDeleteTyre = async () => {
    if (!tyre) return;

    await deleteTyre({ tyre_id: tyre.id });
    onClose();
  };

  return (
    <CustomConfirm
      isOpen={tyre !== null}
      isLoading={isDeleteTyrePending}
      type={CUSTOM_CONFIRM_TYPES.Danger}
      customTitle={t("v8_are_you_sure", "Are you sure?")}
      confirmMsg={t("v8_delete_confirm_message", "Are you sure that you want to delete this? You can't undo this action.")}
      handleCancel={onClose}
      handleConfirm={handleDeleteTyre}
    />
  );
};
